import { type PropsWithChildren, type Ref, type UIEventHandler } from 'react';

import { cn } from '@/lib/utils';

type Props = {
  className?: string;
};

const Layout = ({ children, className }: PropsWithChildren<Props>) => {
  return (
    <div className={cn('flex h-screen w-full flex-col overflow-hidden bg-gray-100', className)}>
      {children}
    </div>
  );
};

type ContentProps = PropsWithChildren<{
  className?: string;
  ref?: Ref<HTMLElement>;
  onScroll?: UIEventHandler<HTMLElement>;
}>;

const Content = ({ children, className, ref, onScroll }: ContentProps) => {
  return (
    <main ref={ref} className={cn('flex min-h-0 flex-1 flex-col', className)} onScroll={onScroll}>
      {children}
    </main>
  );
};

Layout.Content = Content;

export default Layout;
